import { createLogger, format, transports } from 'winston'
const { timestamp, combine, errors, json } = format

export function buildProdLogger() {
  return createLogger({
    format: combine(timestamp(), errors({ stack: true }), json()),
    transports: [new transports.Console()],
  })
}
